document.addEventListener('DOMContentLoaded', function() {
    const cards = document.querySelectorAll('.work-process__card');

    cards.forEach(card => {
        card.addEventListener('click', function() {
            const flyouts = document.querySelectorAll('.work-process__flyout');
            const parentItem = this.closest('.work-process__item');
            const flyout = parentItem.querySelector('.work-process__flyout');
            const isActive = flyout.classList.contains('work-process__flyout--active');

            cards.forEach(c => {
                c.classList.remove('active');
            });

            flyouts.forEach(f => {
                f.classList.remove('work-process__flyout--active');
            });

            if (!isActive && flyout) {
                flyout.classList.add('work-process__flyout--active');
                this.classList.add('active');                
            }
        });
    });
});